import styled from 'styled-components';
import { BLUE_RIBBON_300 } from '../../styles/colors';

interface ButtonContainerProps {
  $size: number;
  $isClickable: boolean;
}

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ButtonContainer = (styled.button<ButtonContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border-radius: 100%;
  background: linear-gradient(180deg, #BDE2F5 0%, #595AFE 54%, #9B1BFF 100%);
  border: 2px solid ${BLUE_RIBBON_300};
  appearance: none;
  padding: 0;
  cursor: ${({ $isClickable }) => $isClickable ? 'pointer' : 'default'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
